// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { paginationStyles } from "@awc/Overrides/Widgets/ProductList/ProductListPagination";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

paginationStyles.pagination = {
    cssOverrides: {
        perPageSelect: css`
            width: 100%;
            & {
                margin: 0;
            }
        `,
        pagination: css`
            & {
                margin: 0;
            }
            ${xScreen("lte", "xs")} {
                justify-content: flex-end;
            }
        `,
    },
    selectProps: {
        cssOverrides: {
            formField: css`
                ${xScreen("lte", "sm")} {
                    flex-direction: row;
                    gap: 8px;
                }
            `,
            formInputWrapper: css`
                ${xScreen("lte", "md")} {
                    width: 100%;
                    &&&& {
                        margin-top: 0;
                    }
                }
            `,
            inputSelect: css`
                width: 64px;
            `,
        },
    },
};
